import { h } from 'preact'
import { useState, memo } from 'preact/compat'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import ArrowDownIcon from '../../../assets/dynamicIcons/ArrowIcon'
import styles from './Group.module.scss'

const Group = ({
  children,
  title = '',
  type= '',
  icon = null,
  withBorder = true,
  withDelimiter = true,
  isContentCollapsed = false,
  paymentMethods
}) => {
  const [isContentVisible, setIsContentVisible] = useState(!isContentCollapsed)
  const handleClick = () => setIsContentVisible(!isContentVisible)

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick()
    }
  }

  const groupClasses = classNames(styles.paymentGroup, {
    [styles.paymentGroupSeparated]: withDelimiter,
  })
  const contentClasses = classNames(styles.paymentGroup__content, {
    [styles.contentBordered]: withBorder,
    [`tenant-overrides-${type}-group-content`]: true
  })
  const headerClasses = classNames(styles.paymentGroup__header, {
    [styles.collapsedHeader]: isContentCollapsed,
    [styles.collapsedHeaderBordered]:
      isContentCollapsed && withBorder && !isContentVisible,
  })

  const header = isContentCollapsed ? (
    <header
      className={headerClasses}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex="0"
      data-testid={`${title}-payment-group-header`}
    >
      <div className={styles.collapsedHeader__title}>
        <img
          src={icon}
          alt={`Icon for ${title}`}
          className={styles.paymentMethodIcon}
        />
        <h2>{title}</h2>
      </div>

      <div className="collapsed-header__icon">
        <ArrowDownIcon
          width={25}
          height={25}
          isTop={isContentVisible}
          color="#092A5E"
        />
      </div>
    </header>
  ) : (
    <header className={headerClasses}>
      <img
        src={icon}
        alt={`Icon for ${title}`}
        className="payment-method-icon"
      />
      <h2 className="text lead medium nospace" aria-label={`Payment methods, there are ${paymentMethods?.length} number of radio buttons for payment methods`}>{title}</h2>
    </header>
  )
  return (
    <div className={groupClasses} data-testid={`${title}-payment-group`}>
      {Boolean(title.length) && header}

      {isContentVisible && (
        <div
          className={contentClasses}
          data-testid={`${title}-payment-group-content`}
        >
          {children}
        </div>
      )}
    </div>
  )
}

Group.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.any,
  children: PropTypes.node,
  withBorder: PropTypes.bool,
  withDelimiter: PropTypes.bool,
  isContentCollapsed: PropTypes.bool,
}

export default memo(Group)
